import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container section-huge"
}
const _hoisted_2 = { class: "d-lg-flex align-items-center gap-3" }
const _hoisted_3 = { class: "product-detail__perfect-system-heading w-100" }
const _hoisted_4 = { class: "ms-lg-auto" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  class: "swiper product-detail__productset-swiper js-productset-swiper",
  ref: "swiper"
}
const _hoisted_9 = { class: "swiper-slide product-detail__productset-swiper-item" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "product-detail__productset-image-wrap" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "product-detail__productset-title" }
const _hoisted_14 = {
  class: "swiper-button-prev product-detail__productset-swiper-prev",
  ref: "prevButton"
}
const _hoisted_15 = {
  class: "swiper-button-next product-detail__productset-swiper-next",
  ref: "nextButton"
}
const _hoisted_16 = {
  key: 0,
  class: "product-detail__product-set-spinner fas fa-spinner fa-spin js-modal-spinner"
}
const _hoisted_17 = {
  class: "modal modal--productset micromodal-slide",
  id: "productSetsModal",
  "aria-hidden": "true",
  ref: "productsetModal"
}
const _hoisted_18 = {
  class: "modal__overlay",
  tabindex: "-1",
  "data-micromodal-close": ""
}
const _hoisted_19 = {
  class: "modal__container",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "modal-1-title"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("header", { class: "modal__header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "modal__close",
    "aria-label": "Close modal",
    "data-micromodal-close": ""
  })
], -1 /* HOISTED */)
const _hoisted_21 = {
  class: "modal__content",
  ref: "modalContentEl"
}
const _hoisted_22 = { class: "container-fluid" }
const _hoisted_23 = { class: "row align-items-start" }
const _hoisted_24 = { class: "col-md-6 modal__images-col" }
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 0,
  class: "modal__product-images-list"
}
const _hoisted_27 = { class: "modal__product-images-list-item" }
const _hoisted_28 = ["src", "alt", "onClick"]
const _hoisted_29 = {
  class: "col-md-6 modal__content-col",
  ref: "columnEl"
}
const _hoisted_30 = { class: "product-detail__benefit-list" }
const _hoisted_31 = { class: "product-detail__benefit-list-item" }
const _hoisted_32 = { class: "product-detail__benefit-flex" }
const _hoisted_33 = {
  key: 0,
  class: "product-detail__benefit-icon-wrap"
}
const _hoisted_34 = ["src", "alt"]
const _hoisted_35 = { class: "product-detail__benefit-content" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 0,
  class: "modal__loading-spinner"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1 /* HOISTED */)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "modal__footer" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fa-sharp fa-solid fa-circle-arrow-left" }, null, -1 /* HOISTED */)
const _hoisted_42 = { class: "modal__prev-text" }
const _hoisted_43 = { class: "modal__next-text" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "fa-sharp fa-solid fa-circle-arrow-right" }, null, -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar")

  return ($setup.productSets.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString($setup.translations.PickYourPerfectSystem), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("select", {
              name: "productSets",
              id: "productSets",
              class: "product-detail__product-sets custom-select",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.selectedOption) = $event)),
              onChange: _cache[1] || (_cache[1] = (...args) => ($setup.getProductSet && $setup.getProductSet(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productSets, (productSet) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: productSet.Id,
                  value: productSet.Id
                }, _toDisplayString(productSet.DisplayTitle), 9 /* TEXT, PROPS */, _hoisted_5))
              }), 128 /* KEYED_FRAGMENT */))
            ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelSelect, $setup.selectedOption]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass(["swiper-wrapper product-detail__productset-swiper-wrapper js-productset-slide-inject", $setup.isHidden ? 'invisible' : '']),
                ref: "swiperWrapper"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productSetItems, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", {
                      onClick: $event => ($setup.openModal(item)),
                      class: "product-detail__productset-card"
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("img", {
                          src: item.ImagePath,
                          alt: item.ImageAlt,
                          class: "product-detail__productset-image"
                        }, null, 8 /* PROPS */, _hoisted_12)
                      ]),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(item.DisplayTitle), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_10)
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ], 2 /* CLASS */),
              _createElementVNode("div", _hoisted_14, null, 512 /* NEED_PATCH */),
              _createElementVNode("div", _hoisted_15, null, 512 /* NEED_PATCH */),
              ($setup.isHidden)
                ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                : _createCommentVNode("v-if", true)
            ], 512 /* NEED_PATCH */)
          ])
        ]),
        _createCommentVNode(" MODAL "),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("main", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("img", {
                        src: $setup.productPrimaryImage,
                        alt: "",
                        ref: "primaryImageDiv",
                        class: _normalizeClass(["modal__productset-primary-image", $setup.moreProductImages.length > 1 && 'modal__productset-primary-image--has-children'])
                      }, null, 10 /* CLASS, PROPS */, _hoisted_25),
                      ($setup.moreProductImages.length > 1)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.moreProductImages, (item, index) => {
                              return (_openBlock(), _createElementBlock("li", _hoisted_27, [
                                _createElementVNode("img", {
                                  src: item.Thumbnails[0].Url,
                                  alt: item.AlternativeText,
                                  class: "modal__product-images-list-image",
                                  onClick: $event => ($setup.swapImageUrl(item))
                                }, null, 8 /* PROPS */, _hoisted_28)
                              ]))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", {
                        class: "modal__title",
                        ref: "titleEl"
                      }, _toDisplayString($setup.productTitle), 513 /* TEXT, NEED_PATCH */),
                      _createElementVNode("div", {
                        class: "modal__product-description",
                        ref: "descriptionEl"
                      }, _toDisplayString($setup.productDescription), 513 /* TEXT, NEED_PATCH */),
                      _createElementVNode("div", {
                        class: "modal__dimensions",
                        ref: "dimensionsEl"
                      }, _toDisplayString($setup.productDimensions), 513 /* TEXT, NEED_PATCH */),
                      _createVNode(_component_perfect_scrollbar, {
                        visible: true,
                        style: _normalizeStyle(`height: ${$setup.benefitsContainerHeight}px`)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("ul", _hoisted_30, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productBenefits, (benefit) => {
                              return (_openBlock(), _createElementBlock("li", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                  (benefit?.Icon?.Thumbnails[0]?.Url)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _createElementVNode("img", {
                                          src: benefit?.Icon?.Thumbnails[0]?.Url,
                                          alt: benefit?.Icon?.AlternativeText,
                                          class: "product-detail__benefit-icon"
                                        }, null, 8 /* PROPS */, _hoisted_34)
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("strong", null, [
                                      _createTextVNode(_toDisplayString(benefit.DisplayTitle) + " ", 1 /* TEXT */),
                                      (benefit?.DisplayTitle && benefit?.Description)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, "|"))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _createTextVNode(" " + _toDisplayString(benefit.Description), 1 /* TEXT */)
                                  ])
                                ])
                              ]))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["style"])
                    ], 512 /* NEED_PATCH */)
                  ])
                ]),
                ($setup.itemIsLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
                  : _createCommentVNode("v-if", true)
              ], 512 /* NEED_PATCH */),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = (...args) => ($setup.loadPrev && $setup.loadPrev(...args)))
                }, [
                  _hoisted_41,
                  _createTextVNode(),
                  _createElementVNode("span", _hoisted_42, _toDisplayString($setup.translations.PreviousProduct), 1 /* TEXT */)
                ]),
                _createElementVNode("div", null, _toDisplayString($setup.getIndexOfCurrent) + " " + _toDisplayString($setup.translations.ProductOf) + " " + _toDisplayString($setup.productSetItems.length), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = (...args) => ($setup.loadNext && $setup.loadNext(...args)))
                }, [
                  _createElementVNode("span", _hoisted_43, _toDisplayString($setup.translations.NextProduct), 1 /* TEXT */),
                  _createTextVNode(),
                  _hoisted_44
                ])
              ])
            ])
          ])
        ], 512 /* NEED_PATCH */)
      ]))
    : _createCommentVNode("v-if", true)
}